<div class="slidecontainer">
  <input
    type="range"
    [min]="min"
    [max]="max"
    [value]="value"
    [step]="step"
    class="slider"
    id="slider"
    [style]="style"
    (input)="setProgress($event.target)" />
</div>
